import type { StablecoinLatestDO, StablecoinListItem } from '../../data/pie-chart.data';
import styleCSS from './table.styles.scss?raw';
import { formatter } from '../../../core/helpers/formatter';
import type { TableChartService } from '../../services/table.service';

export class TableChartComponent extends HTMLElement {
    private _data!: StablecoinListItem[];
    private _columns!: Set<keyof StablecoinListItem>;

    constructor(private tableChartService: TableChartService = window.tbwServices.tableChartService) { super(); }

    async connectedCallback() {
        const shadowRoot = this.attachShadow({ mode: 'open' })
        const style = document.createElement('style')
        style.textContent = styleCSS
        shadowRoot.appendChild(style)

        this.init()
    }

    private async init() {
        try {
            this._data = await this.load()
            this._columns = new Set(this._data.map(item => Object.keys(item).map(key => key as keyof StablecoinListItem)).flat())
            this.setUpGui()
        } catch {
            this.showError()
        }
    }

    private showError() {
        const shadowRoot = this.shadowRoot
        if (!shadowRoot) return
        const errorEl = document.createElement('p')
        errorEl.className = 'table-chart-error'
        errorEl.textContent = 'Unable to load data'
        shadowRoot.appendChild(errorEl)
    }

    private setUpGui() {
        const table = document.createElement('table')

        table.innerHTML = `
        <thead>
            <tr>
                <th>Stablecoin Name</th>
                <th>Market Cap</th>
                <th>Market Share</th>
                <th>Domiciliation</th>
                <th>Jurisdiction</th>
                <th>Regulatory Framework</th>
            </tr>
        </thead>
        <tbody>
            ${this._data.map(item => `<tr>
                <td>${item.stablecoin_name}</td>
                <td>${formatter.formatLargeNumber(item.market_cap) ?? '-'}</td>
                <td>${formatter.formatPercentage(item.market_share) ?? '-'}</td>
                <td>${item.domiciliation ?? '-'}</td>
                <td>${item.juridiction_name ?? '-'}</td>
                <td>${item.regulatory_framework ?? '-'}</td>
                </tr>`).join('')}
        </tbody>
       `
        this.shadowRoot?.appendChild(table)
    }

    private async load(): Promise<StablecoinListItem[]> {
        const data = await this.tableChartService.loadStablecoinsLatest() as StablecoinLatestDO;
        return data.stablecoins_list ?? []
    }

}


